import './../../css/components/basics/hr.scss';

function Hr() {

    return (
        <hr className="hr" />)
}
export default Hr;